module.exports = __webpack_public_path__ + "media/assets/dancing-74d9e3a1cbba59bd9c43fd5881a33fc5.gif";